module.exports = __webpack_public_path__ + "static/v_2-4f9871dd6af629717c138e8566531859.mp4";